import { Button, Dialog, Typogaphy } from 'vnetwork-ui'

interface DraftRestoreDialogProps {
    open: boolean
    onAccept: () => void
    onDecline: () => void
}

const DraftRestoreDialog = ({
    open,
    onAccept,
    onDecline,
}: DraftRestoreDialogProps) => {
    if (!open) return null

    return (
        <Dialog open title="Restore draft?" onClose={onDecline}>
            <Typogaphy>
                You have an unsaved Process Details draft. Restore it?
            </Typogaphy>
            <div className="flex justify-end gap-2 mt-4">
                <Button
                    variant="outlined"
                    onClick={onDecline}
                    className="min-w-[100px]"
                >
                    Discard
                </Button>
                <Button
                    variant="contained"
                    onClick={onAccept}
                    className="min-w-[150px]"
                >
                    Restore
                </Button>
            </div>
        </Dialog>
    )
}

export default DraftRestoreDialog
